import { Injectable, Inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { LogLevel, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { ConfigService } from '@shared/services/config.service';

@Injectable()
export class AuthConfigService {
  constructor(
    private readonly config: ConfigService,
    @Inject(APP_BASE_HREF) private readonly baseHref: string,
  ) {}

  createConfigLoader() {
    console.log('createConfigLoader', this.baseHref);
    return new StsConfigStaticLoader({
      authority: `${this.config.app.azureStsUrl}/${this.config.app.azureNwTenantID}/oauth2/v2.0/authorize`,
      authWellknownEndpointUrl: `${this.config.app.azureStsUrl}/${this.config.app.azureNwTenantID}`,
      redirectUrl: `${window.location.origin}${this.baseHref}callback`,
      clientId: this.config.app.azureClientID,
      responseType: 'code',
      scope: this.config.app.azureScope,
      issValidationOff: true,
      autoUserInfo: false,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      postLogoutRedirectUri: `${window.location.origin}${this.baseHref}`,
      startCheckSession: true,
      silentRenew: true,
      silentRenewUrl: `${window.location.origin}${this.baseHref}silent-renew.html`,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true,
      logLevel: LogLevel.None,
      historyCleanupOff: true,
      renewTimeBeforeTokenExpiresInSeconds: 30,
    });
  }
}
